import React, { useEffect, useCallback } from 'react'
import { observer } from 'mobx-react'
import Typography from '@mui/material/Typography'
import Stack from '@mui/material/Stack'

import { STATUS_TYPE } from 'admin/config/status-type'
import { useStores } from 'admin/hooks'
import { formatDate, formatTimeOnly } from 'admin/utils/helper'
import CustomDataGrid from 'admin/components/data-grid'

const columns = [
  {
    field: 'id',
    headerName: 'ID',
    width: 250,
  },
  {
    field: 'accessoryId',
    headerName: 'Accessory ID',
    width: 200,
  },
  {
    field: 'barcode',
    headerName: 'Barcode',
    width: 250,
  },
  {
    field: 'orderId',
    headerName: 'Invoice ID',
    width: 250,
  },
  {
    field: 'itemId',
    headerName: 'Invoice Item ID',
    width: 250,
  },
  {
    field: 'statusTypeId',
    headerName: 'Status',
    width: 200,
    renderCell: (params) => (
      <Typography variant="h5">
        {params.row.statusTypeId
          ? STATUS_TYPE.find((status) => status.id === params.row.statusTypeId)?.name : '-'}
      </Typography>
    ),
  },
  {
    field: 'createdTime',
    headerName: 'Created at',
    width: 145,
    renderCell: (params) => (
      <Stack direction="column">
        <Typography variant="h5">
          {formatDate(params.row.createdTime)}
        </Typography>
        <Typography variant="h5">
          {formatTimeOnly(params.row.createdTime)}
        </Typography>
      </Stack>
    ),
  },
]

const PosDatagridItemAccessory = () => {
  const { posStore, infoSectionStore } = useStores()

  const handlePageChange = useCallback((param) => {
    posStore.updatePage(param)
  }, [])

  const handlePageSizeChange = useCallback((param) => {
    posStore.updateRowsPerPage(param)
  }, [])

  const handleRowClick = useCallback((rowData) => {
    infoSectionStore.select(rowData.row)
  }, [])

  const onSortModelChange = (param) => {
    if (param.length === 1) {
      posStore.updateQuery('sortBy', param[0].field, true)
      posStore.updateQuery('sortDirection', param[0].sort, true)
      return
    }
    posStore.resetQuery()
  }

  useEffect(() => {
    posStore.fetchItemAccessory()
  }, [posStore.queryParams])

  return (
    <CustomDataGrid
      rows={posStore.list}
      columns={columns}
      handleRowClick={handleRowClick}
      handlePageChange={handlePageChange}
      rowCount={posStore.total}
      pageSize={posStore.rowsPerPage}
      page={posStore.currentPage}
      handlePageSizeChange={handlePageSizeChange}
      onSortModelChange={onSortModelChange}
      loading={posStore.loading}
      rowsPerPageOptions={[20]}
    />
  )
}

export default observer(PosDatagridItemAccessory)
